import React from "react";
import { QueryPermissions } from "../../../utils/graphql/hooks/permissionsHooks";
import { SubscribeV2Connection } from "../../../utils/graphql/hooks/aksHooks";
import {
  SubscribeHeartbeat,
  SubscribeResetFrontend,
} from "../../../utils/graphql/hooks/adminHooks";

interface GlobalDataManagerProps {
  role: string | null;
}

export default function GlobalDataManager({ role }: GlobalDataManagerProps) {
  if (role) QueryPermissions(role);
  SubscribeHeartbeat();
  SubscribeResetFrontend();
  SubscribeV2Connection();
  return <></>;
}
